import { API } from '../config'
import { AxiosResponse } from 'axios'
import { CreatePastureHistoricDto, PastureDto, PastureHistoricDto } from 'src/dto/pasture.dto'

const BASE_URL = '/entity/Pasto'

export class PastureService {
  public async getPastureList(farmId: string): Promise<AxiosResponse<PastureDto[]>> {
    return await API.get<PastureDto[]>(`${BASE_URL}/${farmId}`)
  }

  public async getPastureById(farmId: string, id: string): Promise<AxiosResponse<PastureDto>> {
    return await API.get<PastureDto>(`/entity/idHashRange/Pasto/${farmId}/${id}/getId`)
  }

  public async getPastureHistoricById(farmId: string, id: string): Promise<AxiosResponse<PastureHistoricDto[]>> {
    const encodedId = encodeURIComponent(farmId + '#' + id)
    return await API.get<PastureHistoricDto[]>(`/entity/PastoHistorico/${encodedId}`)
  }

  public async updatePasture(farmId: string, data: any): Promise<AxiosResponse<PastureDto>> {
    return await API.put<PastureDto>(`${BASE_URL}/${farmId}`, data)
  }

  public async createPastureHistoric(
    farmId: string,
    data: CreatePastureHistoricDto
  ): Promise<AxiosResponse<PastureHistoricDto>> {
    return await API.put<PastureHistoricDto>(`/entity/PastoHistorico/${farmId}`, data)
  }
}
